/**
 * DeleteConfirmModal — Video Viewer delete confirm.
 *
 * Aligned with PhotoViewer DeleteConfirmModal (Figma `40000026:11947`).
 *  - 370 wide, cornerRadius 24, bg-popup-gradient
 *  - backdrop rgba(0,0,0,0.64), centered
 *  - trash illustration overflows the top edge (~half outside the modal)
 *  - close X top-right
 *  - title «Удалить видео?»
 *  - description «После удаления видео будет безвозвратно утеряно»
 *  - actions: «Да, удалить» (secondary) | «Отменить» (tertiary)
 *
 * Props:
 *  onConfirm  fn   — DELETE /api/gallery/:id → navigate('/gallery')
 *  onCancel   fn   — close modal, viewer stays
 *  loading?   bool
 */
import { useTranslation } from 'react-i18next';
import { UIButton, Icon } from '../../primitives';

export default function DeleteConfirmModal({ onConfirm, onCancel, loading = false }) {
  const { t } = useTranslation();
  return (
    <div
      className="absolute inset-0 z-40 flex items-center justify-center px-4"
      style={{ background: 'rgba(0,0,0,0.64)' }}
      onClick={onCancel}
      data-testid="delete-modal-backdrop"
    >
      <div
        className="relative rounded-home-24 bg-popup-gradient border border-glass-16 flex flex-col gap-6 p-6"
        style={{ width: 370 }}
        onClick={(e) => e.stopPropagation()}
        data-testid="delete-confirm-modal"
      >
        <img
          src="/icons/trash-illustration.webp"
          alt=""
          aria-hidden="true"
          width={53}
          height={64}
          className="absolute left-1/2 -translate-x-1/2 -top-[40px] pointer-events-none select-none"
        />

        <button
          type="button"
          onClick={onCancel}
          aria-label={t('common.close')}
          className="absolute top-3 right-3 flex items-center justify-center text-text-primary"
          style={{ width: 20, height: 20, opacity: 0.5 }}
        >
          <Icon name="clear" size={16} className="text-text-primary" />
        </button>

        <div className="flex flex-col gap-2 text-center pt-4">
          <p
            className="text-text-primary font-sans font-bold"
            style={{ fontSize: 16, lineHeight: '19px' }}
            data-testid="modal-title"
          >
            {t('viewer.deleteVideoTitle')}
          </p>
          <p
            className="text-text-secondary font-sans"
            style={{ fontSize: 12, lineHeight: '14px', fontWeight: 500 }}
            data-testid="modal-description"
          >
            {t('viewer.deleteVideoDescription')}
          </p>
        </div>

        <div className="flex gap-2">
          <UIButton
            type="secondary"
            size="md"
            className="flex-1"
            onClick={onConfirm}
            disabled={loading}
            data-testid="btn-confirm-delete"
          >
            {loading ? t('viewer.deletingVideo') : t('viewer.confirmDelete')}
          </UIButton>
          <UIButton
            type="tertiary"
            size="md"
            className="flex-1"
            onClick={onCancel}
            disabled={loading}
            data-testid="btn-cancel-delete"
          >
            {t('common.cancel')}
          </UIButton>
        </div>
      </div>
    </div>
  );
}
